import * as React from "react";
const SvgTrailStart = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 10, viewBox: "0 0 9 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 0.5L1.00001 0.5L1 20", stroke: "#C5C6D0" }));
export default SvgTrailStart;
